import _mapValues from 'lodash/mapValues';
// look at these beautiful beasts
export var objectKeys = function (object) { return Object.keys(object); };
export var objectValues = function (object) { return objectKeys(object).map(function (key) { return object[key]; }); };
export var objectValuesToString = function (object) {
    return _mapValues(object, function (value) { return String(value); });
};
export var isType = function (type, value) { return objectValues(type).indexOf(value) > -1; };
export var hasKey = function (type, value) { return objectKeys(type).indexOf(value) > -1; };
